import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3e1bbbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "会計期間", -1))
const _hoisted_2 = {
  id: "accounting-period-form",
  class: "m-auto"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start-date" }, "期首日", -1))
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "期末日", -1))
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.shouldSetDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 会計期間を入力してください。 "))
          : _createCommentVNode("", true),
        _createVNode(_component_dismissible_alert, {
          color: "success",
          message: _ctx.succeedMessage,
          onDismiss: _ctx.dismiss
        }, null, 8, ["message", "onDismiss"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.startDate }]),
              id: "start-date",
              placeholder: "期首日",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.startDate) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
            }, null, 34), [
              [_vModelText, _ctx.values.startDate]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.startDate)
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.endDate }]),
              id: "end-date",
              placeholder: "期末日",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.endDate) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
            }, null, 34), [
              [_vModelText, _ctx.values.endDate]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.endDate)
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary float-right",
              disabled: !_ctx.meta.valid,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setPeriod && _ctx.setPeriod(...args)))
            }, "設定", 8, _hoisted_12)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}